import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/logo-only-red.svg'
import _imports_1 from '@/assets/logo-only.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["id", "poster"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "pr-2"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Make Private", -1)
const _hoisted_7 = { class: "pr-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Add to Playlist", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "btn-icon has-tooltip"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "You Grokked!", -1)
const _hoisted_15 = { class: "pr-2 inline" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "btn-icon-img",
  src: _imports_0,
  alt: "Copy Link"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "Grok it!", -1)
const _hoisted_18 = { class: "btn-icon-img" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "btn-icon-img",
  src: _imports_1,
  alt: "Favorites"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip" }, "View / Hide Comments", -1)
const _hoisted_21 = { class: "pr-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "pt-6 pl-2"
}
const _hoisted_25 = {
  key: 0,
  class: "text-sm italic"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "text-md" }
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_add_to_playlist = _resolveComponent("add-to-playlist")!
  const _component_base_sidebar = _resolveComponent("base-sidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", null, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("video", {
          id: _ctx.videoId,
          class: "w-full max-w-max max-w-screen-lg",
          poster: _ctx.grok.thumbnailUrl,
          controls: "",
          playsinline: "",
          preload: "metadata"
        }, [
          _createElementVNode("source", {
            src: _ctx.grok.mp4Url,
            type: "video/mp4"
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2)
      ]),
      _createElementVNode("footer", null, [
        (_ctx.grok.publishedAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", null, [
                false
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_5, _toDisplayString(_ctx.useNumberFormatter(_ctx.grok.viewCount)) + " views - " + _toDisplayString(_ctx.useTimeSinceFormatter(_ctx.grok.publishedAt)) + " ago ", 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.user?.id === _ctx.grok.user?.id)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-icon has-tooltip",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.unpublish && _ctx.unpublish(...args)))
                  }, [
                    _hoisted_6,
                    _createElementVNode("span", _hoisted_7, [
                      (_openBlock(), _createElementBlock("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: _normalizeClass(["h-6 w-6", 'btn-icon-img']),
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "svg-inline": '',
                        role: 'presentation',
                        focusable: 'false',
                        tabindex: '-1'
                      }, _hoisted_9))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn-icon has-tooltip",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePlaylistSidebar && _ctx.togglePlaylistSidebar(...args)))
              }, [
                _hoisted_10,
                _createElementVNode("span", null, [
                  (_openBlock(), _createElementBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: _normalizeClass(["h-6 w-6", 'btn-icon-img']),
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "svg-inline": '',
                    role: 'presentation',
                    focusable: 'false',
                    tabindex: '-1'
                  }, _hoisted_12))
                ])
              ]),
              (_ctx.grok.userFavorite)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, [
                      _hoisted_16,
                      _createTextVNode(_toDisplayString(_ctx.grok.favoriteCount), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn-icon has-tooltip",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.canGrok && _ctx.canGrok(...args)))
                  }, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(_toDisplayString(_ctx.grok.favoriteCount), 1)
                    ])
                  ])),
              _createElementVNode("button", {
                class: "btn-icon has-tooltip",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.callToggleComments && _ctx.callToggleComments(...args)))
              }, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, [
                  (_openBlock(), _createElementBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: _normalizeClass(["h-6 w-6", 'btn-icon-img']),
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "svg-inline": '',
                    role: 'presentation',
                    focusable: 'false',
                    tabindex: '-1'
                  }, _hoisted_23)),
                  _createTextVNode(_toDisplayString(_ctx.grok.commentsCount), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (_ctx.grok.creatorPlaylists)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grok.creatorPlaylists, (playlist) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: playlist.id
                      }, [
                        _createTextVNode(" Part of @" + _toDisplayString(playlist.user.username) + "'s playlist ", 1),
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.viewUser(playlist.user.username, '/playlists?id=' + playlist.id + '&title=' + playlist.title))
                          }, " \"" + _toDisplayString(playlist.title) + "\" ", 9, _hoisted_26)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.grok.title), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grok.users, (user) => {
                  return (_openBlock(), _createElementBlock("span", { key: user }, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.viewUser(user.username))
                    }, [
                      _createElementVNode("span", null, [
                        _createElementVNode("strong", null, " @" + _toDisplayString(user.username), 1)
                      ])
                    ], 8, _hoisted_29)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_base_sidebar, {
      open: _ctx.playlistSidebarOpen,
      onCloseSidebar: _ctx.togglePlaylistSidebar
    }, {
      default: _withCtx(() => [
        _createVNode(_component_add_to_playlist, {
          item: _ctx.grok,
          onCloseSidebar: _ctx.togglePlaylistSidebar
        }, null, 8, ["item", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["open", "onCloseSidebar"])
  ], 64))
}